import { SUBSCRIBE, SUBSCRIBE_FAILD, SUBSCRIBE_SUCCESS } from "./types";
const initialState = {
  subscriber: undefined,
  failed: undefined,
  loading: undefined,
  errors: undefined,
};

export default function subscriber(state = initialState, action) {
  switch (action.type) {
    case SUBSCRIBE:
      return {
        ...state,
        failed: false,
        loading: true,
      };
    case SUBSCRIBE_SUCCESS:
      return {
        ...state,
        loading: false,
        failed: false,
        subscriber: action.payload,
      };

    case SUBSCRIBE_FAILD:
      return {
        ...state,
        loading: false,
        failed: true,
        errors: action.params.data,
      };

    default:
      return state;
  }
}
